/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthIdentityControllerCheckUserIdAvailability200,
  AuthIdentityControllerFindUserId200,
  AuthPasswordControllerChangePassword200,
  AuthPasswordControllerConfirmPasswordReset200,
  AuthPasswordControllerVerifyCiHash200,
  AuthSessionControllerGetCurrentUser200,
  AuthSessionControllerGetLatestTerms200,
  AuthSessionControllerGetSystemConfig200,
  AuthSessionControllerLogin201,
  AuthSessionControllerLogout201,
  AuthSessionControllerRefresh201,
  AuthSessionControllerSignup201,
  ChangePasswordDto,
  CheckUserIdAvailabilityDto,
  ConfirmPasswordResetDto,
  FindUserIdDto,
  LoginDto,
  NiceAuthControllerBridgeNiceCallbackGetParams,
  NiceAuthControllerBridgeNiceCallbackParams,
  NiceAuthControllerCompleteTestVerification200,
  NiceAuthControllerGetAuthMode200,
  NiceAuthControllerInitializeAuth200,
  NiceAuthControllerProcessCallback200,
  NiceCallbackRequestDto,
  NiceInitRequestDto,
  NiceTestCompleteRequestDto,
  RefreshDto,
  SignupCompleteDto,
  VerifyCiHashDto,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * @summary 시스템 설정 정보 조회 (프로모션 등)
 */
export const authSessionControllerGetSystemConfig = (signal?: AbortSignal) => {
  return api<AuthSessionControllerGetSystemConfig200>({
    url: `/auth/system-config`,
    method: "GET",
    signal,
  });
};

export const getAuthSessionControllerGetSystemConfigQueryKey = () => {
  return [`/auth/system-config`] as const;
};

export const getAuthSessionControllerGetSystemConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthSessionControllerGetSystemConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>
  > = ({ signal }) => authSessionControllerGetSystemConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthSessionControllerGetSystemConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>
>;
export type AuthSessionControllerGetSystemConfigQueryError = ErrorType<unknown>;

export function useAuthSessionControllerGetSystemConfig<
  TData = Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
          TError,
          Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSessionControllerGetSystemConfig<
  TData = Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
          TError,
          Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSessionControllerGetSystemConfig<
  TData = Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 시스템 설정 정보 조회 (프로모션 등)
 */

export function useAuthSessionControllerGetSystemConfig<
  TData = Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetSystemConfig>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getAuthSessionControllerGetSystemConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 사용자 로그인 (Bearer Token - Response Body 반환)
 */
export const authSessionControllerLogin = (
  loginDto: BodyType<LoginDto>,
  signal?: AbortSignal,
) => {
  return api<AuthSessionControllerLogin201>({
    url: `/auth/login`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginDto,
    signal,
  });
};

export const getAuthSessionControllerLoginMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authSessionControllerLogin>>,
    TError,
    { data: BodyType<LoginDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authSessionControllerLogin>>,
  TError,
  { data: BodyType<LoginDto> },
  TContext
> => {
  const mutationKey = ["authSessionControllerLogin"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authSessionControllerLogin>>,
    { data: BodyType<LoginDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authSessionControllerLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthSessionControllerLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof authSessionControllerLogin>>
>;
export type AuthSessionControllerLoginMutationBody = BodyType<LoginDto>;
export type AuthSessionControllerLoginMutationError = ErrorType<void>;

/**
 * @summary 사용자 로그인 (Bearer Token - Response Body 반환)
 */
export const useAuthSessionControllerLogin = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authSessionControllerLogin>>,
      TError,
      { data: BodyType<LoginDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authSessionControllerLogin>>,
  TError,
  { data: BodyType<LoginDto> },
  TContext
> => {
  const mutationOptions = getAuthSessionControllerLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 회원가입 성공 시 Access Token과 Refresh Token을 반환합니다.
 * @summary 회원가입 (Bearer Token 반환)
 */
export const authSessionControllerSignup = (
  signupCompleteDto: BodyType<SignupCompleteDto>,
  signal?: AbortSignal,
) => {
  return api<AuthSessionControllerSignup201>({
    url: `/auth/signup`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: signupCompleteDto,
    signal,
  });
};

export const getAuthSessionControllerSignupMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authSessionControllerSignup>>,
    TError,
    { data: BodyType<SignupCompleteDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authSessionControllerSignup>>,
  TError,
  { data: BodyType<SignupCompleteDto> },
  TContext
> => {
  const mutationKey = ["authSessionControllerSignup"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authSessionControllerSignup>>,
    { data: BodyType<SignupCompleteDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authSessionControllerSignup(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthSessionControllerSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof authSessionControllerSignup>>
>;
export type AuthSessionControllerSignupMutationBody =
  BodyType<SignupCompleteDto>;
export type AuthSessionControllerSignupMutationError = ErrorType<void>;

/**
 * @summary 회원가입 (Bearer Token 반환)
 */
export const useAuthSessionControllerSignup = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authSessionControllerSignup>>,
      TError,
      { data: BodyType<SignupCompleteDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authSessionControllerSignup>>,
  TError,
  { data: BodyType<SignupCompleteDto> },
  TContext
> => {
  const mutationOptions =
    getAuthSessionControllerSignupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 토큰 갱신 (Refresh Token Body 전송)
 */
export const authSessionControllerRefresh = (
  refreshDto: BodyType<RefreshDto>,
  signal?: AbortSignal,
) => {
  return api<AuthSessionControllerRefresh201>({
    url: `/auth/refresh`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: refreshDto,
    signal,
  });
};

export const getAuthSessionControllerRefreshMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authSessionControllerRefresh>>,
    TError,
    { data: BodyType<RefreshDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authSessionControllerRefresh>>,
  TError,
  { data: BodyType<RefreshDto> },
  TContext
> => {
  const mutationKey = ["authSessionControllerRefresh"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authSessionControllerRefresh>>,
    { data: BodyType<RefreshDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authSessionControllerRefresh(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthSessionControllerRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof authSessionControllerRefresh>>
>;
export type AuthSessionControllerRefreshMutationBody = BodyType<RefreshDto>;
export type AuthSessionControllerRefreshMutationError = ErrorType<void>;

/**
 * @summary 토큰 갱신 (Refresh Token Body 전송)
 */
export const useAuthSessionControllerRefresh = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authSessionControllerRefresh>>,
      TError,
      { data: BodyType<RefreshDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authSessionControllerRefresh>>,
  TError,
  { data: BodyType<RefreshDto> },
  TContext
> => {
  const mutationOptions =
    getAuthSessionControllerRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 사용자 로그아웃 (서버 세션 종료)
 */
export const authSessionControllerLogout = (signal?: AbortSignal) => {
  return api<AuthSessionControllerLogout201>({
    url: `/auth/logout`,
    method: "POST",
    signal,
  });
};

export const getAuthSessionControllerLogoutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authSessionControllerLogout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authSessionControllerLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["authSessionControllerLogout"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authSessionControllerLogout>>,
    void
  > = () => {
    return authSessionControllerLogout();
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthSessionControllerLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof authSessionControllerLogout>>
>;

export type AuthSessionControllerLogoutMutationError = ErrorType<void>;

/**
 * @summary 사용자 로그아웃 (서버 세션 종료)
 */
export const useAuthSessionControllerLogout = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authSessionControllerLogout>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authSessionControllerLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getAuthSessionControllerLogoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 현재 사용자 정보 조회
 */
export const authSessionControllerGetCurrentUser = (signal?: AbortSignal) => {
  return api<AuthSessionControllerGetCurrentUser200>({
    url: `/auth/me`,
    method: "GET",
    signal,
  });
};

export const getAuthSessionControllerGetCurrentUserQueryKey = () => {
  return [`/auth/me`] as const;
};

export const getAuthSessionControllerGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthSessionControllerGetCurrentUserQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>
  > = ({ signal }) => authSessionControllerGetCurrentUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthSessionControllerGetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>
>;
export type AuthSessionControllerGetCurrentUserQueryError = ErrorType<void>;

export function useAuthSessionControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSessionControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSessionControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 현재 사용자 정보 조회
 */

export function useAuthSessionControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetCurrentUser>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getAuthSessionControllerGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 최신 약관 목록 조회
 */
export const authSessionControllerGetLatestTerms = (signal?: AbortSignal) => {
  return api<AuthSessionControllerGetLatestTerms200>({
    url: `/auth/terms/latest`,
    method: "GET",
    signal,
  });
};

export const getAuthSessionControllerGetLatestTermsQueryKey = () => {
  return [`/auth/terms/latest`] as const;
};

export const getAuthSessionControllerGetLatestTermsQueryOptions = <
  TData = Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthSessionControllerGetLatestTermsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>
  > = ({ signal }) => authSessionControllerGetLatestTerms(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthSessionControllerGetLatestTermsQueryResult = NonNullable<
  Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>
>;
export type AuthSessionControllerGetLatestTermsQueryError = ErrorType<unknown>;

export function useAuthSessionControllerGetLatestTerms<
  TData = Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
          TError,
          Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSessionControllerGetLatestTerms<
  TData = Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
          TError,
          Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSessionControllerGetLatestTerms<
  TData = Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 최신 약관 목록 조회
 */

export function useAuthSessionControllerGetLatestTerms<
  TData = Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSessionControllerGetLatestTerms>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getAuthSessionControllerGetLatestTermsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 비밀번호 변경 (현재 비밀번호 검증, 새 비밀번호 달라야 함)
 */
export const authPasswordControllerChangePassword = (
  changePasswordDto: BodyType<ChangePasswordDto>,
  signal?: AbortSignal,
) => {
  return api<AuthPasswordControllerChangePassword200>({
    url: `/auth/password/change`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: changePasswordDto,
    signal,
  });
};

export const getAuthPasswordControllerChangePasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authPasswordControllerChangePassword>>,
    TError,
    { data: BodyType<ChangePasswordDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authPasswordControllerChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordDto> },
  TContext
> => {
  const mutationKey = ["authPasswordControllerChangePassword"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authPasswordControllerChangePassword>>,
    { data: BodyType<ChangePasswordDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authPasswordControllerChangePassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthPasswordControllerChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authPasswordControllerChangePassword>>
>;
export type AuthPasswordControllerChangePasswordMutationBody =
  BodyType<ChangePasswordDto>;
export type AuthPasswordControllerChangePasswordMutationError =
  ErrorType<unknown>;

/**
 * @summary 비밀번호 변경 (현재 비밀번호 검증, 새 비밀번호 달라야 함)
 */
export const useAuthPasswordControllerChangePassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authPasswordControllerChangePassword>>,
      TError,
      { data: BodyType<ChangePasswordDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authPasswordControllerChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordDto> },
  TContext
> => {
  const mutationOptions =
    getAuthPasswordControllerChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * NICE 본인인증으로 받은 CI Hash를 검증하고, 검증 성공 시 15분 유효한 password-reset JWT 토큰을 발급합니다.
 * @summary CI Hash 검증 및 비밀번호 재설정 토큰 발급 (Step 1, 분당 5회 제한)
 */
export const authPasswordControllerVerifyCiHash = (
  verifyCiHashDto: BodyType<VerifyCiHashDto>,
  signal?: AbortSignal,
) => {
  return api<AuthPasswordControllerVerifyCiHash200>({
    url: `/auth/password-reset/verify-ci`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: verifyCiHashDto,
    signal,
  });
};

export const getAuthPasswordControllerVerifyCiHashMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authPasswordControllerVerifyCiHash>>,
    TError,
    { data: BodyType<VerifyCiHashDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authPasswordControllerVerifyCiHash>>,
  TError,
  { data: BodyType<VerifyCiHashDto> },
  TContext
> => {
  const mutationKey = ["authPasswordControllerVerifyCiHash"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authPasswordControllerVerifyCiHash>>,
    { data: BodyType<VerifyCiHashDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authPasswordControllerVerifyCiHash(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthPasswordControllerVerifyCiHashMutationResult = NonNullable<
  Awaited<ReturnType<typeof authPasswordControllerVerifyCiHash>>
>;
export type AuthPasswordControllerVerifyCiHashMutationBody =
  BodyType<VerifyCiHashDto>;
export type AuthPasswordControllerVerifyCiHashMutationError =
  ErrorType<unknown>;

/**
 * @summary CI Hash 검증 및 비밀번호 재설정 토큰 발급 (Step 1, 분당 5회 제한)
 */
export const useAuthPasswordControllerVerifyCiHash = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authPasswordControllerVerifyCiHash>>,
      TError,
      { data: BodyType<VerifyCiHashDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authPasswordControllerVerifyCiHash>>,
  TError,
  { data: BodyType<VerifyCiHashDto> },
  TContext
> => {
  const mutationOptions =
    getAuthPasswordControllerVerifyCiHashMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Step 1에서 받은 password-reset JWT 토큰으로 비밀번호를 변경합니다.
 * @summary 비밀번호 재설정 완료 (resetToken + 새 비밀번호) (Step 2, 분당 5회 제한)
 */
export const authPasswordControllerConfirmPasswordReset = (
  confirmPasswordResetDto: BodyType<ConfirmPasswordResetDto>,
  signal?: AbortSignal,
) => {
  return api<AuthPasswordControllerConfirmPasswordReset200>({
    url: `/auth/password-reset/confirm`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: confirmPasswordResetDto,
    signal,
  });
};

export const getAuthPasswordControllerConfirmPasswordResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authPasswordControllerConfirmPasswordReset>>,
    TError,
    { data: BodyType<ConfirmPasswordResetDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authPasswordControllerConfirmPasswordReset>>,
  TError,
  { data: BodyType<ConfirmPasswordResetDto> },
  TContext
> => {
  const mutationKey = ["authPasswordControllerConfirmPasswordReset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authPasswordControllerConfirmPasswordReset>>,
    { data: BodyType<ConfirmPasswordResetDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authPasswordControllerConfirmPasswordReset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthPasswordControllerConfirmPasswordResetMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof authPasswordControllerConfirmPasswordReset>>
  >;
export type AuthPasswordControllerConfirmPasswordResetMutationBody =
  BodyType<ConfirmPasswordResetDto>;
export type AuthPasswordControllerConfirmPasswordResetMutationError =
  ErrorType<unknown>;

/**
 * @summary 비밀번호 재설정 완료 (resetToken + 새 비밀번호) (Step 2, 분당 5회 제한)
 */
export const useAuthPasswordControllerConfirmPasswordReset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authPasswordControllerConfirmPasswordReset>>,
      TError,
      { data: BodyType<ConfirmPasswordResetDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authPasswordControllerConfirmPasswordReset>>,
  TError,
  { data: BodyType<ConfirmPasswordResetDto> },
  TContext
> => {
  const mutationOptions =
    getAuthPasswordControllerConfirmPasswordResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 사용자 ID 찾기 (이름+휴대폰, 마스킹된 ID 반환, 분당 5회 제한)
 */
export const authIdentityControllerFindUserId = (
  findUserIdDto: BodyType<FindUserIdDto>,
  signal?: AbortSignal,
) => {
  return api<AuthIdentityControllerFindUserId200>({
    url: `/auth/find-user-id`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: findUserIdDto,
    signal,
  });
};

export const getAuthIdentityControllerFindUserIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authIdentityControllerFindUserId>>,
    TError,
    { data: BodyType<FindUserIdDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authIdentityControllerFindUserId>>,
  TError,
  { data: BodyType<FindUserIdDto> },
  TContext
> => {
  const mutationKey = ["authIdentityControllerFindUserId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authIdentityControllerFindUserId>>,
    { data: BodyType<FindUserIdDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authIdentityControllerFindUserId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthIdentityControllerFindUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof authIdentityControllerFindUserId>>
>;
export type AuthIdentityControllerFindUserIdMutationBody =
  BodyType<FindUserIdDto>;
export type AuthIdentityControllerFindUserIdMutationError = ErrorType<unknown>;

/**
 * @summary 사용자 ID 찾기 (이름+휴대폰, 마스킹된 ID 반환, 분당 5회 제한)
 */
export const useAuthIdentityControllerFindUserId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authIdentityControllerFindUserId>>,
      TError,
      { data: BodyType<FindUserIdDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authIdentityControllerFindUserId>>,
  TError,
  { data: BodyType<FindUserIdDto> },
  TContext
> => {
  const mutationOptions =
    getAuthIdentityControllerFindUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 사용자 ID 중복 확인 (분당 10회 제한)
 */
export const authIdentityControllerCheckUserIdAvailability = (
  checkUserIdAvailabilityDto: BodyType<CheckUserIdAvailabilityDto>,
  signal?: AbortSignal,
) => {
  return api<AuthIdentityControllerCheckUserIdAvailability200>({
    url: `/auth/check-user-id-availability`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: checkUserIdAvailabilityDto,
    signal,
  });
};

export const getAuthIdentityControllerCheckUserIdAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authIdentityControllerCheckUserIdAvailability>>,
    TError,
    { data: BodyType<CheckUserIdAvailabilityDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authIdentityControllerCheckUserIdAvailability>>,
  TError,
  { data: BodyType<CheckUserIdAvailabilityDto> },
  TContext
> => {
  const mutationKey = ["authIdentityControllerCheckUserIdAvailability"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authIdentityControllerCheckUserIdAvailability>>,
    { data: BodyType<CheckUserIdAvailabilityDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authIdentityControllerCheckUserIdAvailability(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthIdentityControllerCheckUserIdAvailabilityMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof authIdentityControllerCheckUserIdAvailability>>
  >;
export type AuthIdentityControllerCheckUserIdAvailabilityMutationBody =
  BodyType<CheckUserIdAvailabilityDto>;
export type AuthIdentityControllerCheckUserIdAvailabilityMutationError =
  ErrorType<unknown>;

/**
 * @summary 사용자 ID 중복 확인 (분당 10회 제한)
 */
export const useAuthIdentityControllerCheckUserIdAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authIdentityControllerCheckUserIdAvailability>>,
      TError,
      { data: BodyType<CheckUserIdAvailabilityDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authIdentityControllerCheckUserIdAvailability>>,
  TError,
  { data: BodyType<CheckUserIdAvailabilityDto> },
  TContext
> => {
  const mutationOptions =
    getAuthIdentityControllerCheckUserIdAvailabilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Generate encrypted data and crypto token for NICE module initialization
 * @summary Initialize NICE authentication
 */
export const niceAuthControllerInitializeAuth = (
  niceInitRequestDto: BodyType<NiceInitRequestDto>,
  signal?: AbortSignal,
) => {
  return api<NiceAuthControllerInitializeAuth200>({
    url: `/auth/nice/init`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: niceInitRequestDto,
    signal,
  });
};

export const getNiceAuthControllerInitializeAuthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof niceAuthControllerInitializeAuth>>,
    TError,
    { data: BodyType<NiceInitRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof niceAuthControllerInitializeAuth>>,
  TError,
  { data: BodyType<NiceInitRequestDto> },
  TContext
> => {
  const mutationKey = ["niceAuthControllerInitializeAuth"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof niceAuthControllerInitializeAuth>>,
    { data: BodyType<NiceInitRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return niceAuthControllerInitializeAuth(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NiceAuthControllerInitializeAuthMutationResult = NonNullable<
  Awaited<ReturnType<typeof niceAuthControllerInitializeAuth>>
>;
export type NiceAuthControllerInitializeAuthMutationBody =
  BodyType<NiceInitRequestDto>;
export type NiceAuthControllerInitializeAuthMutationError = ErrorType<unknown>;

/**
 * @summary Initialize NICE authentication
 */
export const useNiceAuthControllerInitializeAuth = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof niceAuthControllerInitializeAuth>>,
      TError,
      { data: BodyType<NiceInitRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof niceAuthControllerInitializeAuth>>,
  TError,
  { data: BodyType<NiceInitRequestDto> },
  TContext
> => {
  const mutationOptions =
    getNiceAuthControllerInitializeAuthMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Handle NICE callback response, decrypt personal data, and store verification result
 * @summary Process NICE authentication callback
 */
export const niceAuthControllerProcessCallback = (
  niceCallbackRequestDto: BodyType<NiceCallbackRequestDto>,
  signal?: AbortSignal,
) => {
  return api<NiceAuthControllerProcessCallback200>({
    url: `/auth/nice/callback`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: niceCallbackRequestDto,
    signal,
  });
};

export const getNiceAuthControllerProcessCallbackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof niceAuthControllerProcessCallback>>,
    TError,
    { data: BodyType<NiceCallbackRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof niceAuthControllerProcessCallback>>,
  TError,
  { data: BodyType<NiceCallbackRequestDto> },
  TContext
> => {
  const mutationKey = ["niceAuthControllerProcessCallback"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof niceAuthControllerProcessCallback>>,
    { data: BodyType<NiceCallbackRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return niceAuthControllerProcessCallback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NiceAuthControllerProcessCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof niceAuthControllerProcessCallback>>
>;
export type NiceAuthControllerProcessCallbackMutationBody =
  BodyType<NiceCallbackRequestDto>;
export type NiceAuthControllerProcessCallbackMutationError = ErrorType<unknown>;

/**
 * @summary Process NICE authentication callback
 */
export const useNiceAuthControllerProcessCallback = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof niceAuthControllerProcessCallback>>,
      TError,
      { data: BodyType<NiceCallbackRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof niceAuthControllerProcessCallback>>,
  TError,
  { data: BodyType<NiceCallbackRequestDto> },
  TContext
> => {
  const mutationOptions =
    getNiceAuthControllerProcessCallbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 시험 서버(NICE_TEST_MODE=true, 운영 아님)면 true — 화면은 [본인인증] 에서 실제 PASS 대신 시험용 창을 연다. 운영에서는 늘 false.
 * @summary 본인인증 시험 모드 여부
 */
export const niceAuthControllerGetAuthMode = (signal?: AbortSignal) => {
  return api<NiceAuthControllerGetAuthMode200>({
    url: `/auth/nice/mode`,
    method: "GET",
    signal,
  });
};

export const getNiceAuthControllerGetAuthModeQueryKey = () => {
  return [`/auth/nice/mode`] as const;
};

export const getNiceAuthControllerGetAuthModeQueryOptions = <
  TData = Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getNiceAuthControllerGetAuthModeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>
  > = ({ signal }) => niceAuthControllerGetAuthMode(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NiceAuthControllerGetAuthModeQueryResult = NonNullable<
  Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>
>;
export type NiceAuthControllerGetAuthModeQueryError = ErrorType<unknown>;

export function useNiceAuthControllerGetAuthMode<
  TData = Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
          TError,
          Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNiceAuthControllerGetAuthMode<
  TData = Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
          TError,
          Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNiceAuthControllerGetAuthMode<
  TData = Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 본인인증 시험 모드 여부
 */

export function useNiceAuthControllerGetAuthMode<
  TData = Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerGetAuthMode>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getNiceAuthControllerGetAuthModeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 시험용 본인인증 창에서 넣은 값으로 NICE 완료 기록과 같은 기록을 남긴다. 시험 모드가 아니면 404.
 * @summary 본인인증 시험 모드 완료(시험 서버 전용)
 */
export const niceAuthControllerCompleteTestVerification = (
  niceTestCompleteRequestDto: BodyType<NiceTestCompleteRequestDto>,
  signal?: AbortSignal,
) => {
  return api<NiceAuthControllerCompleteTestVerification200>({
    url: `/auth/nice/test/complete`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: niceTestCompleteRequestDto,
    signal,
  });
};

export const getNiceAuthControllerCompleteTestVerificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof niceAuthControllerCompleteTestVerification>>,
    TError,
    { data: BodyType<NiceTestCompleteRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof niceAuthControllerCompleteTestVerification>>,
  TError,
  { data: BodyType<NiceTestCompleteRequestDto> },
  TContext
> => {
  const mutationKey = ["niceAuthControllerCompleteTestVerification"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof niceAuthControllerCompleteTestVerification>>,
    { data: BodyType<NiceTestCompleteRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return niceAuthControllerCompleteTestVerification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NiceAuthControllerCompleteTestVerificationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof niceAuthControllerCompleteTestVerification>>
  >;
export type NiceAuthControllerCompleteTestVerificationMutationBody =
  BodyType<NiceTestCompleteRequestDto>;
export type NiceAuthControllerCompleteTestVerificationMutationError =
  ErrorType<unknown>;

/**
 * @summary 본인인증 시험 모드 완료(시험 서버 전용)
 */
export const useNiceAuthControllerCompleteTestVerification = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof niceAuthControllerCompleteTestVerification>>,
      TError,
      { data: BodyType<NiceTestCompleteRequestDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof niceAuthControllerCompleteTestVerification>>,
  TError,
  { data: BodyType<NiceTestCompleteRequestDto> },
  TContext
> => {
  const mutationOptions =
    getNiceAuthControllerCompleteTestVerificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * NICE POST 콜백을 서버에서 받아 프론트엔드 콜백 페이지로 302 리다이렉트합니다. cross-origin/CSP 제약을 받는 인라인 HTML 핸드오프를 대체합니다.
 * @summary NICE 콜백 브릿지 (POST → 프론트 콜백 302 리다이렉트)
 */
export const niceAuthControllerBridgeNiceCallback = (
  params: NiceAuthControllerBridgeNiceCallbackParams,
  signal?: AbortSignal,
) => {
  return api<unknown>({
    url: `/auth/nice/bridge`,
    method: "POST",
    params,
    signal,
  });
};

export const getNiceAuthControllerBridgeNiceCallbackMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallback>>,
    TError,
    { params: NiceAuthControllerBridgeNiceCallbackParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallback>>,
  TError,
  { params: NiceAuthControllerBridgeNiceCallbackParams },
  TContext
> => {
  const mutationKey = ["niceAuthControllerBridgeNiceCallback"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallback>>,
    { params: NiceAuthControllerBridgeNiceCallbackParams }
  > = (props) => {
    const { params } = props ?? {};

    return niceAuthControllerBridgeNiceCallback(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type NiceAuthControllerBridgeNiceCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallback>>
>;

export type NiceAuthControllerBridgeNiceCallbackMutationError = ErrorType<void>;

/**
 * @summary NICE 콜백 브릿지 (POST → 프론트 콜백 302 리다이렉트)
 */
export const useNiceAuthControllerBridgeNiceCallback = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallback>>,
      TError,
      { params: NiceAuthControllerBridgeNiceCallbackParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallback>>,
  TError,
  { params: NiceAuthControllerBridgeNiceCallbackParams },
  TContext
> => {
  const mutationOptions =
    getNiceAuthControllerBridgeNiceCallbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * NICE가 GET 리다이렉트로 복귀하는 흐름(모바일 PASS 앱)에서 암호화 페이로드가 쿼리스트링으로 전달되는 경우를 처리합니다.
 * @summary NICE 콜백 브릿지 (GET 리다이렉트 복귀 경로)
 */
export const niceAuthControllerBridgeNiceCallbackGet = (
  params: NiceAuthControllerBridgeNiceCallbackGetParams,
  signal?: AbortSignal,
) => {
  return api<unknown>({
    url: `/auth/nice/bridge`,
    method: "GET",
    params,
    signal,
  });
};

export const getNiceAuthControllerBridgeNiceCallbackGetQueryKey = (
  params?: NiceAuthControllerBridgeNiceCallbackGetParams,
) => {
  return [`/auth/nice/bridge`, ...(params ? [params] : [])] as const;
};

export const getNiceAuthControllerBridgeNiceCallbackGetQueryOptions = <
  TData = Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
  TError = ErrorType<void>,
>(
  params: NiceAuthControllerBridgeNiceCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNiceAuthControllerBridgeNiceCallbackGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>
  > = ({ signal }) => niceAuthControllerBridgeNiceCallbackGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NiceAuthControllerBridgeNiceCallbackGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>
>;
export type NiceAuthControllerBridgeNiceCallbackGetQueryError = ErrorType<void>;

export function useNiceAuthControllerBridgeNiceCallbackGet<
  TData = Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
  TError = ErrorType<void>,
>(
  params: NiceAuthControllerBridgeNiceCallbackGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNiceAuthControllerBridgeNiceCallbackGet<
  TData = Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
  TError = ErrorType<void>,
>(
  params: NiceAuthControllerBridgeNiceCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNiceAuthControllerBridgeNiceCallbackGet<
  TData = Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
  TError = ErrorType<void>,
>(
  params: NiceAuthControllerBridgeNiceCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary NICE 콜백 브릿지 (GET 리다이렉트 복귀 경로)
 */

export function useNiceAuthControllerBridgeNiceCallbackGet<
  TData = Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
  TError = ErrorType<void>,
>(
  params: NiceAuthControllerBridgeNiceCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof niceAuthControllerBridgeNiceCallbackGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getNiceAuthControllerBridgeNiceCallbackGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
